/**
 * Sauce custom section – modal logic (media + product/author).
 * Call SauceCustom.init(sectionId, blocksData, defaultCta) from the section with Liquid-generated data.
 */
(function () {
  'use strict';

  function renderModalContent(modal, sectionId, data, defaultCta) {
    var mediaEl = document.getElementById('sauce-custom-modal-media-' + sectionId);
    var productEl = document.getElementById('sauce-custom-modal-product-' + sectionId);
    if (!mediaEl || !productEl) return;

    mediaEl.innerHTML = '';
    if (data.mediaType === 'video' && data.videoSrc) {
      var video = document.createElement('video');
      if (data.imageSrc) {
        video.poster = data.imageSrc;
        video.preload = 'auto';
      }
      video.src = data.videoSrc;
      video.autoplay = true;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.controls = true;
      video.style.width = '100%';
      video.style.height = '100%';
      video.style.objectFit = 'cover';
      mediaEl.appendChild(video);
      video.play().catch(function () {});
    } else {
      var img = document.createElement('img');
      img.src = data.imageSrc;
      img.alt = '';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
      mediaEl.appendChild(img);
    }

    var authorBlock = '';
    if (data.profileImage || data.instagramHandle || (data.commentHtml && data.commentHtml.trim())) {
      var handle = (data.instagramHandle || '').replace(/^@/, '');
      authorBlock =
        '<div class="sauce-custom-modal__author">' +
        (data.profileImage
          ? '<div class="sauce-custom-modal__author-avatar"><img src="' + data.profileImage + '" alt=""></div>'
          : '') +
        '<div class="sauce-custom-modal__author-meta">' +
        (handle ? '<p class="sauce-custom-modal__author-handle">By @' + handle + '</p>' : '') +
        (data.commentHtml && data.commentHtml.trim()
          ? '<div class="sauce-custom-modal__author-comment rte">' + data.commentHtml + '</div>'
          : '') +
        '</div></div>';
    }
    if (!data.productUrl) {
      productEl.innerHTML = authorBlock;
      return;
    }
    var name =
      data.productName && data.productName.trim() ? data.productName : data.productTitle;
    productEl.innerHTML =
      '<div class="sauce-custom-modal__product-image">' +
      '<a href="' +
      data.productUrl +
      '" data-instant><img src="' +
      data.productImage +
      '" alt=""></a></div>' +
      '<div class="sauce-custom-modal__product-info">' +
      '<div class="price-list">' +
      data.productPrice +
      '</div>' +
      '<a href="' +
      data.productUrl +
      '" class="h6" data-instant>' +
      name +
      '</a>' +
      '<a href="' +
      data.productUrl +
      '" class="button" data-instant>' +
      (data.ctaText || defaultCta) +
      '</a>' +
      '</div>' +
      authorBlock;
  }

  function init(sectionId, blocksData, defaultCta) {
    var modal = document.getElementById('sauce-custom-modal-' + sectionId);
    if (!modal) return;

    var currentIndex = 0;

    function openModal(index) {
      if (index < 0 || index >= blocksData.length) return;
      currentIndex = index;
      renderModalContent(modal, sectionId, blocksData[currentIndex], defaultCta);
      modal.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.removeAttribute('open');
      document.body.style.overflow = '';
      var mediaEl = document.getElementById('sauce-custom-modal-media-' + sectionId);
      if (mediaEl) {
        var video = mediaEl.querySelector('video');
        if (video) video.pause();
      }
    }

    document
      .querySelectorAll('#shopify-section-' + sectionId + ' .sauce-custom-item[data-sauce-index]')
      .forEach(function (btn) {
        var index = parseInt(btn.getAttribute('data-sauce-index'), 10);
        if (!isNaN(index) && blocksData[index]) {
          btn.addEventListener('click', function () {
            openModal(index);
          });
        }
      });

    modal.querySelectorAll('.sauce-custom-modal__close').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
      var prevBtn = e.target.closest('.sauce-custom-modal__prev');
      var nextBtn = e.target.closest('.sauce-custom-modal__next');
      if (prevBtn) {
        e.preventDefault();
        currentIndex = currentIndex <= 0 ? blocksData.length - 1 : currentIndex - 1;
        renderModalContent(modal, sectionId, blocksData[currentIndex], defaultCta);
      }
      if (nextBtn) {
        e.preventDefault();
        currentIndex = currentIndex >= blocksData.length - 1 ? 0 : currentIndex + 1;
        renderModalContent(modal, sectionId, blocksData[currentIndex], defaultCta);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.hasAttribute('open')) closeModal();
    });
  }

  window.SauceCustom = { init: init };
})();
